import React from "react";
import { Chip, ChipProps } from "@mui/material";
import { styled } from "@mui/system";

const StyledChip = styled(Chip)(({ theme }) => ({
  // "& .MuiChip-deleteIcon": {
  //   color: "#5494DC",
  // },
  // "& .MuiChip-outlinedPrimary": {
  //   border: "1px solid #3281D6",
  //   color: "#5494DC",
  // },
}));

export default function CustomizedChip(props: ChipProps) {
  const { label, disabled, onDelete } = props;

  return (
    <StyledChip
      variant="outlined"
      color="primary"
      label={label}
      disabled={disabled}
      onDelete={onDelete}
    />
  );
}
